import React from 'react'
import { plusIcon, MyAgroLogo } from 'assets/svg/svgs'
import { MenuSvgs } from 'assets'

import { t } from 'i18next'
import { findPermission } from '../../helpers/findPermission'
import { constants } from 'helpers'
import { Button } from 'components'
import { useBaseNavigation } from 'hooks/useBaseNavigation'

export const useNavBarConfig = ({
    permissionsState,
    hasUnreadNotifications,
    clearClientSearchHandler,
    clearSelectedFilter
}: {
    permissionsState: []
    hasUnreadNotifications: boolean
    clearClientSearchHandler: () => void
    clearSelectedFilter: ({
        selectedFilter
    }: {
        selectedFilter: string | undefined
    }) => void
}) => {
    const {
        ProfileIcon,
        HomeIcon,
        VillageIcon,
        NotificationMessageIcon
    } = MenuSvgs
    const navigate = useBaseNavigation()
    const { VIEW_VILLAGES, CAN_VIEW_LOGO_BUTTON, UPDATE_CLIENT } = constants

    const canViewVillages = findPermission(permissionsState, VIEW_VILLAGES)
    const displayLogoButton = findPermission(
        permissionsState,
        CAN_VIEW_LOGO_BUTTON
    )
    const canEnroll = findPermission(permissionsState, UPDATE_CLIENT)

    const canViewNewDesign = findPermission(
        permissionsState,
        constants.CAN_VIEW_VILLAGE_PAGE_REDESIGN
    )

    const clientSearchNavHandler = () => {
        clearClientSearchHandler()
        navigate('/client-search')
    }

    const villageNavigationHandler = () => {
        if (canViewNewDesign) {
            clearSelectedFilter({ selectedFilter: undefined })
        }
        navigate('/village')
    }

    const mobileMenuConfig = [
        {
            name: t('menu.home'),
            path: 'home',
            href: 'home',
            icon: <HomeIcon />,
            isVisible: true,
            onClickCallback: () => navigate('/home')
        },
        {
            name: t('menu.village'),
            path: 'village',
            href: 'village',
            icon: <VillageIcon />,
            isVisible: canViewVillages,
            onClickCallback: villageNavigationHandler
        },
        {
            name: displayLogoButton ? (
                <span className={'menu-btn-logo'}>
                    <MyAgroLogo size={40} />
                </span>
            ) : (
                <span className={'menu-plus'}>{plusIcon({})}</span>
            ),
            path: 'client-search',
            href: 'client-search',
            disableActive: true,
            onClickCallback: clientSearchNavHandler,
            isVisible: canEnroll
        },
        {
            name: t('messages'),
            path: 'notifications',
            href: 'notification/messages',
            icon: (
                <div className={'menu--notification-icon'}>
                    <NotificationMessageIcon />
                    {hasUnreadNotifications && (
                        <div className={'menu--unread-notification-dot'}></div>
                    )}
                </div>
            ),
            isVisible: true,
            onClickCallback: () => navigate('/notification/messages')
        },
        {
            name: t('menu.profile'),
            path: 'profile',
            href: 'profile',
            icon: <ProfileIcon />,
            isVisible: true,
            onClickCallback: () => navigate('/profile')
        }
    ]

    const desktopMenuConfig = [
        {
            name: t('menu.home'),
            path: 'home',
            href: 'home',
            icon: <HomeIcon />,
            isVisible: true,
            onClickCallback: () => navigate('/home')
        },
        {
            name: t('menu.village'),
            path: 'village',
            href: 'village',
            icon: <VillageIcon />,
            isVisible: canViewVillages,
            onClickCallback: villageNavigationHandler
        },
        {
            name: t('messages'),
            path: 'notifications',
            href: 'notification/messages',
            icon: (
                <div className={'menu--notification-icon'}>
                    <NotificationMessageIcon />
                    {hasUnreadNotifications && (
                        <div className={'menu--unread-notification-dot'}></div>
                    )}
                </div>
            ),
            isVisible: true,
            onClickCallback: () => navigate('/notification/messages')
        },
        {
            name: t('menu.profile'),
            path: 'profile',
            href: 'profile',
            icon: <ProfileIcon />,
            isVisible: true,
            onClickCallback: () => navigate('/profile')
        },
        {
            name: (
                <Button
                    icon={plusIcon({})}
                    iconPos="left"
                    size="small"
                    style="primary"
                >
                    {t('menu.addClient').toString()}
                </Button>
            ),
            path: 'client-search',
            href: 'client-search',
            onClickCallback: clientSearchNavHandler,
            disableActive: true,
            isVisible: canEnroll
        }
    ]

    return { mobileMenuConfig, desktopMenuConfig }
}
